import { forceAssert } from '../../../../common-functions';
import type { TypeOrArray } from '../../../../common-interfaces';
import { isArrayDropDownResult } from '../../../../fields/drop-down/drop-down-common';
import type { JsonDataItem } from '../../../../generic-types';
import type { VisibilityCondition } from '../../visibility-condition.interfaces';
import type { ITargetValueConverter, ValueConverterReturnType } from './i-target-value-converter';

export class EntityIdTargetValueConverter implements ITargetValueConverter {
  public convert(condition: VisibilityCondition, data: JsonDataItem): TypeOrArray<ValueConverterReturnType> {
    if (condition.sourceFieldId && data?.[condition.sourceFieldId]) {
      const dataItem = data[condition.sourceFieldId];
      if (Array.isArray(dataItem) && Array.isArray(condition.targetValueId)) {
        if (isArrayDropDownResult(dataItem)) {
          const dataItemValues = dataItem.map((item) => Number(item.value));
          return [
            dataItemValues,
            condition.targetValueId,
            condition.negation || false,
            condition.filterOperator || 'EQUALS',
          ];
        }

        return [dataItem, condition.targetValueId, condition.negation || false, condition.filterOperator || 'EQUALS'];
      } else {
        return [
          Number(forceAssert<Record<string, unknown>>(dataItem)?.['value']),
          Number(condition.targetValueId),
          condition.negation || false,
          condition.filterOperator || 'EQUALS',
        ];
      }
    }

    // if there is no data then we still need to send back the other pieces so the condition evaluates successfully
    return [undefined, condition.targetValueId, condition.negation || false, condition.filterOperator || 'EQUALS'];
  }
}
